import { lazy } from "react";

const NotiConfigPage = lazy(() => import("./main"));
const CreateNotiConfigPage = lazy(() => import("./create"));
const UpdateNotiConfigPage = lazy(() => import("./update"));

export { NotiConfigPage, CreateNotiConfigPage, UpdateNotiConfigPage };
